import { UnionMap, UnionValueMap } from '../types/union-map';
import { OperatingSystemFamily } from './browser';

export type WindowsStoreLinkName = 'WindowsApp' | 'WindowsAppMac' | 'WindowsAppIOS' | 'WindowsAppAndroid';

export const WindowsStoreLinkName: UnionMap<WindowsStoreLinkName> = {
    WindowsApp: 'WindowsApp',
    WindowsAppMac: 'WindowsAppMac',
    WindowsAppIOS: 'WindowsAppIOS',
    WindowsAppAndroid: 'WindowsAppAndroid',
};

export const WindowsAppLink = 'https://aka.ms/devcenter/devportal/install-windows-app';
export const WindowsAppMacStoreLink = 'http://aka.ms/devcenter/devportal/windows-app-mac';
export const WindowsAppIOSLink = 'https://aka.ms/devcenter/devportal/windows-app-ios';
export const WindowsAppAndroidLink = 'https://aka.ms/devcenter/devportal/windows-app-android';

export const WindowsStoreLinks: UnionValueMap<WindowsStoreLinkName, string> = {
    WindowsApp: WindowsAppLink,
    WindowsAppMac: WindowsAppMacStoreLink,
    WindowsAppIOS: WindowsAppIOSLink,
    WindowsAppAndroid: WindowsAppAndroidLink,
};

export const getLinkForOS = (os: OperatingSystemFamily): string => {
    switch (os) {
        case OperatingSystemFamily.Windows:
            return WindowsStoreLinks.WindowsApp;
        case OperatingSystemFamily.MacOS:
            return WindowsStoreLinks.WindowsAppMac;
        case OperatingSystemFamily.IOS:
            return WindowsStoreLinks.WindowsAppIOS;
        case OperatingSystemFamily.Android:
            return WindowsStoreLinks.WindowsAppAndroid;
        default:
            return WindowsStoreLinks.WindowsApp;
    }
};
